import { render, staticRenderFns } from "./StudentUserStatisticsAdmin.vue?vue&type=template&id=1a0cb88e&scoped=true"
import script from "./StudentUserStatisticsAdmin.vue?vue&type=script&lang=js"
export * from "./StudentUserStatisticsAdmin.vue?vue&type=script&lang=js"
import style0 from "./StudentUserStatisticsAdmin.vue?vue&type=style&index=0&id=1a0cb88e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0cb88e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a0cb88e')) {
      api.createRecord('1a0cb88e', component.options)
    } else {
      api.reload('1a0cb88e', component.options)
    }
    module.hot.accept("./StudentUserStatisticsAdmin.vue?vue&type=template&id=1a0cb88e&scoped=true", function () {
      api.rerender('1a0cb88e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/StudentUserStatisticsAdmin.vue"
export default component.exports